import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Course from "../pages/course/page";
import Support from "../pages/support/page";
import Resources from "../pages/resources/page";
import Contact from "../pages/contact/page";
import FAQ from "../pages/faq/page";
import BlogPage from "../pages/blog/page";
import BlogPostPage from "../pages/blog/post/page";
import BlogAdminPage from "../pages/blog/admin/page";
import BlogEditPage from "../pages/blog/admin/edit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/course",
    element: <Course />,
  },
  {
    path: "/support",
    element: <Support />,
  },
  {
    path: "/resources",
    element: <Resources />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/blog/admin/new",
    element: <BlogEditPage />,
  },
  {
    path: "/blog/admin/edit/:id",
    element: <BlogEditPage />,
  },
  {
    path: "/blog/admin",
    element: <BlogAdminPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogPostPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;